import { useCheckout } from "@stripe/react-stripe-js/checkout";
import { useRef, useState } from "react";

import { useEffect } from "react";
import styled from "styled-components";

const PaymentError = styled.div`
  background: #fee;
  color: #c33;
  padding: 12px 16px;
  border-radius: 8px;
  margin-top: 15px;
  font-size: 14px;
  text-align: center;
  border: 1px solid #fcc;
`;

const PayNowButton = styled.button`
  width: 100%;
  background: #0b6dff;
  color: white;
  border: none;
  padding: 14px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: 20px;

  &:hover:not(:disabled) {
    background:rgb(0, 105, 217);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const ReminderText = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #000000;
    margin-top: 8px;

    @media (min-width: 768px) {
        font-size: 14px;
    }
`;

export function CreditCardForm({ isNoTrialVariation = true }: { isNoTrialVariation?: boolean }) {
  const checkout = useCheckout();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const isCheckoutMounted = useRef(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [paymentElementLoaded, setPaymentElementLoaded] = useState(false);

  useEffect(() => {
    if (checkout.type === "success" && !isCheckoutMounted.current) {
      isCheckoutMounted.current = true;

      const paymentElement = checkout.checkout.createPaymentElement();
      paymentElement.mount("#payment-element");
      paymentElement.on("ready", () => {
        setPaymentElementLoaded(true);
      });
    }
  }, [checkout]);

  useEffect(() => {
    if (paymentElementLoaded) {
      containerRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [paymentElementLoaded]);

  const handlePaymentSubmit = async (event: any) => {
    event.preventDefault();
    if (checkout.type !== "success" || !checkout) {
      console.warn("Checkout is not ready");
      return;
    }

    setErrorMessage(null);
    setIsLoading(true);

    const result = await checkout.checkout.confirm();
    setIsLoading(false);

    // confirm sends payment details etc. using the PaymentElement
    if (result.type === "error") {
      setErrorMessage(result.error.message);
    } else {
      // Stripe handles redirection where required.
      // result usually contains no error, probably redirect being handled internally
      console.log("Payment successful", result);
    }
  };

  return (
    <div ref={containerRef}>
      <form onSubmit={handlePaymentSubmit}>
        <div id="payment-element" style={{ marginTop: "16px" }} />
        {errorMessage && <PaymentError>{errorMessage}</PaymentError>}
        <ReminderText>
          {isNoTrialVariation
            ? "Covered by our 30-day money-back guarantee."
            : "We’ll remind you 2 days before your trial ends."}
        </ReminderText>
        <div>
          <PayNowButton type="submit" disabled={isLoading}>
            {isNoTrialVariation ? "Get my plan" : "Start trial"}
          </PayNowButton>
        </div>
      </form>
    </div>
  );     
}
